import { fields } from '@gasman/smush';

const NOTE_NAMES_BY_VALUE = { 0: '---', 255: 'R--' };
const NOTE_VALUES_BY_NAME = { '---': 0, 'R--': 255 };

for (var octave = 0; octave < 9; octave++) {
    [
        'C-',
        'C#',
        'D-',
        'D#',
        'E-',
        'F-',
        'F#',
        'G-',
        'G#',
        'A-',
        'A#',
        'B-',
    ].forEach((noteName, index) => {
        var noteVal = 1 + octave * 12 + index;
        NOTE_NAMES_BY_VALUE[noteVal] = noteName + octave;
        NOTE_VALUES_BY_NAME[noteName + octave] = noteVal;
    });
}

class NoteField extends fields.ValueField {
    constructor(name, opts) {
        super(name, opts);
        this.default = this.default || 0;
        this.linkedSampleField = opts.linkedSampleField || 0;
    }
    pack(val) {
        return NOTE_NAMES_BY_VALUE[val];
    }
    unpack(val) {
        return NOTE_VALUES_BY_NAME[val];
    }
}

export { NOTE_NAMES_BY_VALUE, NOTE_VALUES_BY_NAME, NoteField };
